import React from 'react';
import IconSvg from '../../../../common/IconSvg';
import { TSideIcon } from '../../../services/NavIcon.types';

export const DepositIcon = ({ styles }: TSideIcon) => (
  <IconSvg name="DepositGG" className="svgIcon" sx={styles.icon} />
);
export const ContactIcon = ({ styles }: TSideIcon) => (
  <IconSvg name="ContactUsGG" className="svgIcon" sx={styles.icon} />
);
export const MyAccountIcon = ({ styles }: TSideIcon) => (
  <IconSvg name="MyAccountGG" className="svgIcon" sx={styles.icon} />
);
export const SportsIcon = ({ styles }: TSideIcon) => (
  <IconSvg name="SportsGG" className="svgIcon" sx={styles.icon} />
);
export const ResponsibleGamblingIcon = ({ styles }: TSideIcon) => (
  <IconSvg name="ResponsibleGambling" className="svgIcon" sx={styles.icon} />
);
